export const styles = {
  global: {
    body: {
      color: `white`,
      background: `colours.colour-1`
    }
  }
};
